import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    obj: { age: 12, name: "xyz", hairColor: "black" },
  },
  {
    obj: { 12: "age", xyz: "name", black: "hairColor" },
  },
  {
    obj: { 1: 2, 3: 4, 5: 6 },
  },
  {
    obj: { number: 1, String: "abc", Objcet: {}, arr: [], function: () => {} },
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { obj } = test;
      let outcome1 = output()(obj);
      let outcome2 = Solution(obj);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
